import { Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import geojson from 'geojson';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { form, FormField, required, submit, validate } from '@angular/forms/signals';

@Component({
  selector: 'app-leaflet-geojson-form',
  templateUrl: './geojson.component.html',
  styleUrls: ['./geojson.component.scss'],
  imports: [
    FormField,
    MatInputModule,
    MatDialogModule,
    MatButtonModule,
  ],
})
export class LeafletGeoJSONFormComponent {
  dialog = inject<MatDialogRef<LeafletGeoJSONFormComponent>>(MatDialogRef);
  data = inject<geojson.FeatureCollection>(MAT_DIALOG_DATA);

  featureCollection = computed(() => {
    const v = this.data || { type: "FeatureCollection", features: [] };
    return JSON.stringify(v, null, 2);
  });

  geojsonForm = form(signal<{
    geojson: string;
  }>({
    geojson: this.featureCollection(),
  }), (schemaPath) => {
    required(schemaPath.geojson);

    validate(schemaPath.geojson, ({ value }) => {
      const v = value();

      try {
        JSON.parse(v);
      } catch {
        return {
          kind: 'geojson',
          message: 'Invalid JSON',
        }
      }

      return null;
    });
  });

  geojsonError = computed(() => {
    const errors = this.geojsonForm.geojson().errors();
    if (errors.length) {
      return errors[0].message;
    }

    return null;
  });

  public submit(event: Event) {
    event.preventDefault();

    submit(this.geojsonForm, async () => {
      const json = JSON.parse(
        this.geojsonForm.geojson().value()
      );

      this.dialog.close(json);
    });
  }
}
